module.exports = __webpack_public_path__ + "img/buddy_mouth-05.8899d76e.svg";